import React from "react";

import classes from "./Review.module.css";

const Review = ({ review }) => {
  return (
    <div className={classes["review"]}>
      <img className={classes["img"]} src={review.image} alt="" />
      <h3 className={classes["name"]}>{review.name}</h3>
      <p className={classes["comment"]}>{review.comment}</p>
    </div>
  );
};

export default Review;
